export enum DMN_PLANO {
  PREVIDENCIAL_A = "0001",
  PREVIDENCIAL_B = "0002"
}